import { ValidableField } from './ValidableField';
import { ChangeEvent } from 'react';
import { Textarea } from '@apia/theme';
import { makeValidableField } from './makeValidableField';

export const ValidableTextarea = makeValidableField(
  ({ context, label, path, onChange, ...props }) => {
    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
      context.setValue(path, event.target.value);
      onChange?.(event);
    };

    return (
      <ValidableField
        context={context}
        path={path}
        label={label}
        {...props}
        className={`textarea ${props.className}`}
      >
        <Textarea
          name={path}
          value={context.getValue(path)}
          onChange={handleChange}
        />
      </ValidableField>
    );
  },
);
